import { FaCircleCheck, FaCircleExclamation } from 'react-icons/fa6'

export default function Toast({ message, show, type = 'success' }) {
  const bg =
    type === 'success'
      ? 'bg-ocean-800/90 border border-ocean-600/40'
      : 'bg-red-900/90 border border-red-600/40'
  const Icon =
    type === 'success' ? FaCircleCheck : FaCircleExclamation
  const iconCls =
    type === 'success' ? 'text-ocean-400' : 'text-red-400'

  return (
    <div
      className={`toast ${bg} backdrop-blur-xl ${show ? 'show' : ''}`}
      role="alert"
    >
      <Icon className={`text-lg ${iconCls}`} />
      <span className="text-sm font-medium text-white">{message}</span>
    </div>
  )
}